import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  HStack,
  Icon,
  useColorModeValue,
  Badge,
  Flex,
} from '@chakra-ui/react';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ClientsSection: React.FC = () => {
  const { t, ready } = useTranslation();
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');

  const testimonials = [
    {
      quote: t('clientsSection.testimonials.testimonial1.quote'),
      author: t('clientsSection.testimonials.testimonial1.author'),
      position: t('clientsSection.testimonials.testimonial1.position'),
      company: t('clientsSection.testimonials.testimonial1.company'),
      rating: 5,
    },
    {
      quote: t('clientsSection.testimonials.testimonial2.quote'),
      author: t('clientsSection.testimonials.testimonial2.author'),
      position: t('clientsSection.testimonials.testimonial2.position'),
      company: t('clientsSection.testimonials.testimonial2.company'),
      rating: 5,
    },
    {
      quote: t('clientsSection.testimonials.testimonial3.quote'),
      author: t('clientsSection.testimonials.testimonial3.author'),
      position: t('clientsSection.testimonials.testimonial3.position'),
      company: t('clientsSection.testimonials.testimonial3.company'),
      rating: 5,
    },
  ];

  if (!ready) {
    return null;
  }

  return (
    <Box bg={bgColor} py={{ base: 12, md: 16 }}>
      <Container maxW='7xl'>
        <VStack spacing={{ base: 8, md: 12 }}>
          <VStack spacing={4} textAlign='center'>
            <Heading size={{ base: 'xl', md: '2xl' }} color='primary.500'>
              {t('clientsSection.title')}
            </Heading>
            <Text
              fontSize={{ base: 'md', md: 'lg' }}
              color='gray.500'
              maxW='2xl'
            >
              {t('clientsSection.subtitle')}
            </Text>
          </VStack>

          {/* Testimonials */}
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 6, md: 8 }}>
            {testimonials.map((testimonial, index) => (
              <Box
                key={index}
                bg={cardBg}
                p={{ base: 4, md: 6 }}
                borderRadius='lg'
                boxShadow='md'
                border='1px solid'
                borderColor={useColorModeValue('gray.200', 'gray.600')}
                position='relative'
                display='flex'
                flexDirection='column'
                h='full'
              >
                <Flex
                  direction='column'
                  gap={{ base: 3, md: 4 }}
                  align='flex-start'
                  flex={1}
                >
                  <Icon
                    as={FaQuoteLeft}
                    boxSize={{ base: 5, md: 6 }}
                    color='primary.500'
                  />
                  <Text
                    fontSize={{ base: 'xs', md: 'sm' }}
                    color={useColorModeValue('gray.600', 'gray.400')}
                    fontStyle='italic'
                    flex={1}
                  >
                    "{testimonial.quote}"
                  </Text>

                  <HStack spacing={2}>
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Icon
                        key={i}
                        as={FaStar}
                        color={useColorModeValue('black', 'white')}
                        boxSize={4}
                      />
                    ))}
                  </HStack>

                  <VStack spacing={1} align='start' mt='auto' w='full'>
                    <Text
                      color={useColorModeValue('gray.700', 'white')}
                      fontWeight='bold'
                      fontSize={{ base: 'xs', md: 'sm' }}
                    >
                      {testimonial.author}
                    </Text>
                    <Text fontSize={{ base: '2xs', md: 'xs' }} color='gray.500'>
                      {testimonial.position}
                    </Text>
                    <Badge colorScheme='primary' variant='outline' size='sm'>
                      {testimonial.company}
                    </Badge>
                  </VStack>
                </Flex>
              </Box>
            ))}
          </SimpleGrid>

          {/* CTA */}
          {/* <Box
            bg='primary.500'
            color='white'
            p={{ base: 6, md: 8 }}
            borderRadius='xl'
            textAlign='center'
            w='full'
            maxW='4xl'
          >
            <VStack spacing={{ base: 4, md: 6 }}>
              <Heading size={{ base: 'md', md: 'lg' }}>
                {t('clientsSection.cta.title')}
              </Heading>
              <Text fontSize={{ base: 'md', md: 'lg' }} maxW='2xl'>
                {t('clientsSection.cta.description')}
              </Text>
              <VStack spacing={4} w={{ base: 'full', md: 'auto' }}>
                <HStack
                  spacing={4}
                  flexWrap={{ base: 'wrap', md: 'nowrap' }}
                  justify='center'
                >
                  <Button
                    size={{ base: 'md', md: 'lg' }}
                    variant='solid'
                    bg='white'
                    color='primary.500'
                    _hover={{ bg: 'gray.100' }}
                    w={{ base: 'full', sm: 'auto' }}
                    minW={{ base: 'auto', sm: '180px' }}
                  >
                    {t('clientsSection.cta.scheduleConsultation')}
                  </Button>
                  <Button
                    size={{ base: 'md', md: 'lg' }}
                    variant='outline'
                    borderColor='white'
                    color='white'
                    _hover={{ bg: 'whiteAlpha.200' }}
                    w={{ base: 'full', sm: 'auto' }}
                    minW={{ base: 'auto', sm: '180px' }}
                  >
                    {t('clientsSection.cta.viewCaseStudies')}
                  </Button>
                </HStack>
              </VStack>
            </VStack>
          </Box> */}
        </VStack>
      </Container>
    </Box>
  );
};

export default ClientsSection;
